module.exports = __webpack_public_path__ + "img/folder.56a45f58.svg";